<template>
  <keep-alive :include="include" :max="8">
    <router-view :key="$route.fullPath" v-if="showRouterView"></router-view>
  </keep-alive>
</template>
<script>
import { keepAliveInclude } from "@/util/keepAlive";
import { defineComponent, nextTick, onMounted } from "@vue/composition-api";
import { actions } from "@oppein/op-utils";
import { computed, ref } from "@vue/composition-api";

export default defineComponent({
  setup() {
    const showRouterView = ref(true);
    onMounted(() => {
      actions.onGlobalStateChange((state) => {
        const { keepAlive, reload } = state;
        if (keepAlive.statue && keepAlive.meta.componentName) {
          // mtds2主应用中中删除访问记录
          const delIndex = keepAliveInclude.value.findIndex(
            (v) => v.meta.componentName === keepAlive.meta.componentName,
          );
          if (delIndex >= 0) {
            keepAliveInclude.value.splice(delIndex, 1);
          }
        } else if (reload.status) {
          // mtds2主应用中要求重新加载页面
          const delIndex = keepAliveInclude.value.findIndex(
            (v) => v.meta.componentName === reload.value.meta.componentName,
          );
          if (delIndex >= 0) {
            keepAliveInclude.value.splice(delIndex, 1);
          }
          showRouterView.value = false;
          nextTick(() => {
            showRouterView.value = true;
          });
        }
      });
    });
    const include = computed(() => {
      return keepAliveInclude.value.map((route) => route.meta.componentName);
    });
    return {
      showRouterView,
      include,
    };
  },
});
</script>



// WEBPACK FOOTER //
// PageContend.vue?2723f508